import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account';
import { NativeResources, SearchTermSubCategory } from '@ariksa/inventory-core';
import { HStack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getProviderAlias } from 'components/DataDisplay';
import { GrayIconButton } from 'components/DataEntry';
import {
  BellIcon,
  GraphIcon,
  NotifyIcon,
  OverviewIcon,
  ThirdPartyIcon,
  TicketIcon,
} from 'components/Icons';
import { useMetadataDrawerTabs } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/hooks/useMetadataDrawerTabs';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';
import { useActiveResourceActions } from 'containers/ActiveCloudResource/hooks/useActiveResourceActions';
import { MetadataTabs } from 'containers/ActiveCloudResource/types';
import { selectSharedState } from 'containers/SharedState/selectors';
import { useRedirectToSecurityGraph } from 'containers/Visibility/SecurityGraphNext/hooks/useRedirectToSecurityGraph';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';

export const ResourceVulnerabilityActions = () => {
  const { resourceInsight } = useSelector(selectVulnerabilities);
  const { securityGraphAvailability } = useSelector(selectSharedState);
  const { data: insight } = resourceInsight;
  const { redirectToSecurityGraph } = useRedirectToSecurityGraph();

  const { onOpenMetadata } = useActiveResourceContext();
  const { updateActiveResource } = useActiveResourceActions();
  const { getTabIndex } = useMetadataDrawerTabs();

  const openMetadataDrawer = (showAlerts = false) => {
    updateActiveResource({
      uuid: insight.uuid,
      resourceId: insight.resource_id,
      resourceType: insight.native_name as NativeResources,
      accountId: insight.account ?? '',
      cloudProvider: insight?.provider as CloudProviders,
    });
    let tabIndex = 0;
    if (showAlerts) {
      tabIndex = getTabIndex(insight.native_name, MetadataTabs.Alerts);
    }
    onOpenMetadata(tabIndex);
  };

  return (
    <HStack spacing={8}>
      <GrayIconButton
        leftIcon={<OverviewIcon />}
        onClick={() => openMetadataDrawer()}
        showGrayBg
      >
        Details
      </GrayIconButton>
      <GrayIconButton
        onClick={() => {}}
        leftIcon={<ThirdPartyIcon strokeWidth={1.5} />}
        iconSize="26px"
        iconSpacing={1}
        isDisabled
      >
        {getProviderAlias(resourceInsight.data?.provider)}
      </GrayIconButton>
      <GrayIconButton
        onClick={() => {}}
        leftIcon={<NotifyIcon />}
        iconSize="20px"
        isDisabled
      >
        Notify
      </GrayIconButton>
      <GrayIconButton
        onClick={() => {}}
        leftIcon={<TicketIcon />}
        iconSize="22px"
        isDisabled
      >
        Create Ticket
      </GrayIconButton>
      <GrayIconButton
        leftIcon={<GraphIcon />}
        onClick={() => {
          const { native_name, uuid, resource_id, account } = insight;
          redirectToSecurityGraph({
            mapType: 'posture',
            resourceType:
              native_name === NativeResources.ElasticContainerRegistry
                ? 'ContainerImage'
                : native_name,
            resourceUuid:
              native_name === NativeResources.ElasticContainerRegistry
                ? insight?.id
                : uuid,
            resourceId: resource_id,
            account: account ?? insight?.account,
            sourceTab: MetadataTabs.Vulnerabilities,
            ...(insight?.native_name ===
            NativeResources.ElasticContainerRegistry
              ? {}
              : { subCategory: SearchTermSubCategory.Vulnerable }),
          });
        }}
        isLoading={securityGraphAvailability.isLoading}
        isDisabled={!securityGraphAvailability.data?.[insight?.native_name!]}
        showGrayBg
      >
        Security Graph
      </GrayIconButton>
      <GrayIconButton
        leftIcon={<BellIcon />}
        onClick={() => openMetadataDrawer(true)}
        showGrayBg
      >
        Show All Alerts
      </GrayIconButton>
    </HStack>
  );
};
